import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInputPasswordHide = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 16,
	viewBox: "0 0 21 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.44871 14.7081C7.64428 15.2102 8.94055 15.5 10.3 15.5C15.4768 15.5 19.1411 11.4069 20.479 8.54572L20.4793 8.54509C20.6402 8.19977 20.6403 7.79995 20.4791 7.45459L20.479 7.45429C19.8211 6.04716 18.8362 4.68677 17.6088 3.54801L16.9018 4.25502C18.0383 5.30167 18.9574 6.56108 19.5731 7.87785C19.6089 7.9546 19.6091 8.04455 19.5731 8.12214C18.3227 10.7963 14.9348 14.5 10.3 14.5C9.22821 14.5 8.19312 14.2967 7.22039 13.9365L6.44871 14.7081ZM13.421 2.07898C12.4363 1.70908 11.387 1.5 10.3 1.5C5.66535 1.5 2.27754 5.20345 1.02701 7.87755C0.990998 7.9547 0.990998 8.04491 1.02701 8.12206C1.64805 9.45032 2.57782 10.7202 3.72785 11.7721L3.02074 12.4793C1.77966 11.3349 0.784207 9.96387 0.12099 8.5453L0.120859 8.54502C-0.0402862 8.19979 -0.0402862 7.79983 0.120859 7.45459L0.121002 7.45428C1.45889 4.59309 5.12323 0.5 10.3 0.5C11.6746 0.5 12.9846 0.79631 14.1913 1.30873L13.421 2.07898Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.0422 11.1146C10.1269 11.1215 10.2124 11.125 10.2988 11.125C12.0247 11.125 13.4238 9.72589 13.4238 8C13.4238 7.91361 13.4203 7.82803 13.4134 7.74341L12.1933 8.9635C11.9894 9.36365 11.6625 9.69061 11.2623 9.89452L10.0422 11.1146ZM9.44768 6.05232C8.95838 6.26645 8.56528 6.65955 8.35115 7.14885L7.1891 8.3109C7.179 8.20864 7.17383 8.10492 7.17383 8C7.17383 6.27411 8.57294 4.875 10.2988 4.875C10.4037 4.875 10.5075 4.88017 10.6097 4.89027L9.44768 6.05232Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.5 15L17.5 0L18.2071 0.707107L3.20711 15.7071L2.5 15Z",
			fill: "black"
		})
	]
});
export default SvgInputPasswordHide;
